export const APP_STORE_ID = "6479883365";
export const APPLE_TEAM_ID = "83G62PSP38";
export const PLAY_STORE_ID = "com.entspannungshelden.app";
export const BUNDLE_IDENTIFIER = "com.entspannungshelden.app";
